module.exports = __webpack_public_path__ + "img/customer-img1.2fa8edb8.png";